import React from 'react'
import HowCan from './HowCan/HowCan'
import Locations from './Locations/Locations'
import Map from './Map/Map'

function Contact() {
  return (
    <>
    <HowCan/>
    <Locations/>
    <Map/>
    </>
  )
}

export default Contact
